﻿import { mifareDataReadFrameOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";
export const conf = defineEntity({
  ...entityFactory("mifare-data-read-frame"),
  endpoint: "mifare-data-read-frame",
  operations: mifareDataReadFrameOps,
  roleView: [ROLE.CONTAINER_VIEW, ROLE.CONTAINER_ADMIN],
  roleAdmin: [ROLE.CONTAINER_ADMIN],
  singularName: (t) => t("Mifare data read frame"),
  name: (t) => t("Mifare data read frames"),
  syncCustomerFilter: true,
});
export default conf;
